import { cn } from "@/utils/classnames"
import { forwardRef, InputHTMLAttributes } from "react"

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export const RoundedInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, ref) => {
  return (
    <input
      ref={ref}
      {...props}
      style={{
        WebkitAppearance: "none",
      }}
      className={cn(
        "rounded-full border border-bg-3 bg-bg-2 px-9 py-4 placeholder-fg-3 outline-none transition-all text-body1-md focus:outline-none focus:ring-0 lg:text-body1-lg",
        props.className
      )}
    />
  )
})

RoundedInput.displayName = "Input"
